module.exports = __webpack_public_path__ + "static/img/management_icon_blue.cfd35ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/management_icon_blue.svg
// module id = eIRk
// module chunks = 1